import { Checkbox, FormControl, InputGroup, useDisclosure, useToast } from "@chakra-ui/react"
import _, { get } from "lodash"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { NavigateFunction, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { ATTENDANCE, SESSION } from "../../../../consts/methods.consts"
import { ATTENDANCE_TAGS, DROPDOWN_TAGS, SESSION_TAGS } from "../../../../consts/tags.consts"
import { useGetQuery, usePostMutation } from "../../../../services/api.service"
import { ToastService } from "../../../../services/toast.service"
import { showConfirmDialog } from "../../../../store/reducers/confirm-modal"
import ChakraTable, { ChakraTableColumns } from "../../../common/chakra-table/ChakraTable"
import { PageHeaderActions } from "../../../common/page-header/PageHeader"
import { SectionCard } from "../../../common/section-card/SectionCard"
import { useObjChange } from "../../../hooks"

const AttendanceTable = ({ isAttendanceConfirmed, isPoRole }: any) => {
    const navigate: NavigateFunction = useNavigate()
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const [page, setPage] = useState(1)
    const [create, { isLoading: mutating }] = usePostMutation();
    const [searchKey, setSearchKey]: any = useState()
    const [length, setLength] = useState(15)
    const toast = new ToastService(useToast());
    const dispatch = useDispatch()
    const disclosure = useDisclosure()

    const [modifiedTableData, setModifiedTableData] = useState([])

    const { data: _response, isLoading, isFetching } = useGetQuery({
        method: SESSION.SESSION_ATTENDANCE_LIST,
        body: {
            page: page,
            key: searchKey,
            id,
            length: Number(length),
        },
        providesTags: [ATTENDANCE_TAGS.LIST]
    })

    const response = get(_response, 'message', {})
    const data = get(response, 'data', [])
    const isConfirmed = get(response, 'is_confirmed', false)
    const isPO = get(response, 'is_po_role', false)
    const isPA = get(response, 'is_pa_role')
    const isAllSelected = !modifiedTableData.some((row: any) => row?.present == 0);

    console.log(isAllSelected, 'isAllSelected')

    const loading = mutating || isLoading

    const { isChanged, setInitialObj } = useObjChange(modifiedTableData)

    useEffect(() => {
        setModifiedTableData(data)
        setInitialObj(data)
    }, [JSON.stringify(response)])


    const onConfirmHandler = async () => {
        try {
            const res = await create({
                method: ATTENDANCE.ATTENDANCE_CONFIRM,
                body: { session: id },
                invalidatesTags: [ATTENDANCE_TAGS.LIST, DROPDOWN_TAGS.LIST, SESSION_TAGS.VIEW]
            }).unwrap();

            toast.setTitle("Success").setDescription("Attendance have been confirmed successfully ").showSuccessToast();

        } catch (error: any) {
            let message = JSON.parse(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(JSON.parse(message)?.message).showErrorToast();
        }
    }



    const bulkSaveAttendance = async () => {
        try {
            const res = await create({
                method: ATTENDANCE.CREATE_BULK_ATTENDANCE,
                body: { data: modifiedTableData, session: id },
                invalidatesTags: [ATTENDANCE_TAGS.VIEW, ATTENDANCE_TAGS.LIST, DROPDOWN_TAGS.LIST]
            }).unwrap();

            toast.setTitle("Success").setDescription("Attendance have been saved successfully ").showSuccessToast();

        } catch (error: any) {
            let message = JSON.parse(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(JSON.parse(message)?.message).showErrorToast();
        }
    }

    const onRevertToDraftHandler = async () => {
        try {
            const res = await create({
                method: ATTENDANCE.REVERT_TO_DRAFT,
                body: { session: id },
                invalidatesTags: [ATTENDANCE_TAGS.LIST, DROPDOWN_TAGS.LIST, SESSION_TAGS.VIEW]
            }).unwrap();
            toast.setTitle("Success").setDescription("Attendance have been reverted to draft successfully ").showSuccessToast();
        } catch (error: any) {
            let message = JSON.parse(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(JSON.parse(message)?.message).showErrorToast();
        }
    }

    const selectAllHandler = () => {

        if (isAllSelected) {
            const newData: any = modifiedTableData.map((item: any) => ({ ...item, present: 0, status: 'Absent' }))
            setModifiedTableData(newData)
            return
        }

        const newData: any = modifiedTableData.map((item: any) => ({ ...item, present: 1, status: 'Present' }))
        setModifiedTableData(newData)
    }


    const ATTENDANCE_LIST_TAB_COLUMNS: ChakraTableColumns = [
        {
            header: "Present",
            accessor: "present",
            customRenderer(value: any, item) {
                return (
                    <CheckBoxCell value={value} item={item} modifiedTableData={modifiedTableData} setModifiedTableData={setModifiedTableData}
                        isPA={isPA}
                        isPO={isPO}
                        session={id}
                        isChanged={isChanged}
                    />
                )
            },
        },
        {
            header: "Student",
            accessor: "full_name",
        },
        {
            header: "NIC",
            accessor: "nic",
        },
        {
            header: "Attendance Status",
            accessor: "status",
            width: 400,
            customRenderer(value: any, item) {
                const className = (value == 'Present') ? 'bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded' :
                    'bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded'
                return (
                    <div>
                        <span className={className}>{value}</span>
                    </div>
                )
            },
        },

        {
            header: "Document Status",
            accessor: "docstatus",
            width: 400,
            customRenderer(value: any, item) {
                const className = (value == 'Draft') ? 'bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded' :
                    'bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded'
                return (
                    <div>
                        <span className={className}>{value}</span>
                    </div>
                )
            },
        },
    ]

    // const tableLineClickHandler = (line: any) => {
    //     navigate(`/app/student/${_.get(line, 'student_id')}`)
    // }


    const actions: PageHeaderActions = [
        ...isConfirmed ? [
            ...isPoRole ? [{
                text: "Revert to Draft Attendance",
                onClick: onRevertToDraftHandler,
                isDisabled: loading,
                buttonVariant: "solid",
                buttonColorScheme: "teal"
            }] : []
        ] : [
            ...(isPA || isPO) ? [
                {

                    text: isAllSelected ? "Unselect All" : "Select All",
                    onClick: selectAllHandler,
                    isDisabled: isConfirmed || loading,
                    buttonVariant: "solid",
                    buttonColorScheme: "teal",
                    confirmation: false
                },
                {

                    text: "Save",
                    onClick: bulkSaveAttendance,
                    isDisabled: !isChanged || isConfirmed || loading,
                    buttonVariant: "solid",
                    buttonColorScheme: "teal",
                    confirmation: true
                }] : [],
            ...isPO ? [{
                text: "Confirm Attendance",
                onClick: onConfirmHandler,
                isDisabled: isConfirmed || loading || isChanged,
                buttonVariant: "solid",
                buttonColorScheme: "teal"
            }] : []
        ]
    ]

    return (
        <div>

            <SectionCard actions={actions} bg={'white'} subTitle="" title="Attendance" p={3}>
                <ChakraTable isFetching={isFetching || loading} isLoading={isLoading || loading} size={"sm"} header
                    columns={ATTENDANCE_LIST_TAB_COLUMNS} data={modifiedTableData} />
            </SectionCard>
        </div>
    )
}

export default AttendanceTable


const CheckBoxCell = ({ value, item, modifiedTableData, setModifiedTableData, isPO, isPA, session, isChanged }: any) => {
    const confirmed = get(item, 'confirmed', false)
    const index = modifiedTableData?.findIndex((line: any) => line?.student_id === item?.student_id);
    const [create, { isLoading: mutating }] = usePostMutation();
    const toast = new ToastService(useToast());
    const dispatch = useDispatch()

    const editable = !confirmed && (isPA || isPO)


    if (index === -1) return <></>

    const onChange = (e: any) => {
        let _value = get(e, 'target.value')
        let status = 'Absent'

        if (value == 1) {
            _value = 0
        }
        else {
            _value = 1
            status = 'Present'
        }

        if (isPO && !isChanged) {
            dispatch(showConfirmDialog({
                title: 'Confirmation Required!',
                subtitle: 'Are you sure you want to continue the action?',
                onConfirm: async () => {
                    create({
                        method: ATTENDANCE.CREATE_SINGLE_ATTENDANCE,
                        body: { session: session, student: get(item, 'student_id'), present: _value },
                        invalidatesTags: [ATTENDANCE_TAGS.LIST, DROPDOWN_TAGS.LIST, SESSION_TAGS.VIEW]
                    }).unwrap().then((res: any) => {
                        const updatedData: any = [...modifiedTableData];
                        updatedData[index] = { ...item, present: _value, status }
                        setModifiedTableData(updatedData);

                        toast.setTitle("Success").setDescription("Attendance have been updated successfully ").showSuccessToast();
                    }).catch((error: any) => {
                        let message = JSON.parse(_.get(error?.data, '_server_messages', {}))
                        if (message) toast.setTitle("Error").setDescription(JSON.parse(message)?.message).showErrorToast();
                    })
                }
            }))

            return
        }

        const updatedData: any = [...modifiedTableData];
        updatedData[index] = { ...item, present: _value, status }
        setModifiedTableData(updatedData);

    }

    return (

        <FormControl className="w-full h-full">
            <InputGroup className="w-full h-full" size='md'>
                <Checkbox className="w-full h-full" shadow={"sm"} isDisabled={!editable} borderColor={'gray.300'} size={'lg'} name={'present'} isChecked={value} onChange={onChange} />
            </InputGroup>
        </FormControl>

    )
}